module.exports = __webpack_public_path__ + "static/media/iPhone14_3.7de8a6ae.png";